import 'parsleyjs'
import 'javascripts/impression.js'
import 'javascripts/parsley.custom_validators.js'
import { gtmDataLayerEvent} from 'javascripts/general_scripts'
import 'jquery-ujs'
import ResizeObserver from 'resize-observer-polyfill'
import { positionReviews } from "javascripts/landingpages/review_positioner";
import 'javascripts/landingpages/form_submission_controller.js'
import { phoneVerificationConversionTracking } from 'javascripts/utils'

const ro = new ResizeObserver(() => positionReviews());

gtmDataLayerEvent();
// maintain position of reviews even as form height changes
positionReviews();
ro.observe($('#leadform').get(0));

// sign out user remotely and swap in empty email field
$('.change-email').on('ajax:success', () => {
  $.getScript(`${location.pathname.replace(/\/$/, '')}.js`, () => { $('#leadform').attr('action', '/users') })
});

phoneVerificationConversionTracking();
